import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { OccEndpointsService } from '@spartacus/core';

@Injectable({
  providedIn: 'root'
})
export class ProductNotificationService {
  constructor(
    private http: HttpClient,
    private occEndpointsService: OccEndpointsService
  ) {}

  notifyEmail(email: string, productCode: string): Observable<boolean> {
    const url = this.occEndpointsService.buildUrl('productNotificationSubmit', {
      urlParams: { productCode },
      queryParams: { email }
    });

    return this.http.post<boolean>(url, {});
  }
}
